// src/components/Auth/WarningPopup.jsx
import warning from "../../assets/warning.svg";
const WarningPopup = ({ onClose }) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-80 flex justify-center items-center z-50">
      <div className="bg-white py-[47px] px-[90px] rounded-lg relative flex flex-col gap-2 items-center">
        <div className="text-red-500 mb-4">
          <img src={warning} alt="" className="" />
        </div>

        <p className="text-center mb-6 font-medium">
          Please log in first to continue.
        </p>

        <button
          onClick={onClose}
          className="bg-[#55C880] text-white px-5 py-2 rounded-[10px] hover:bg-green-700 transition-colors duration-200 mb-4"
        >
          Ok
        </button>
      </div>
    </div>
  );
};

export default WarningPopup;
